/** Разделы меню в оверлее */
export enum BarberShopSection {
	FACIAL_HAIR = 'facial_hair',
	EYEBROWS = 'eyebrows',
	MAKEUP = 'makeup',
	BLUSH = 'blush',
	LIPSTICK = 'lipstick',
	BODY_HAIR = 'body_hair',
	HAIR = 'hair',
	EYES = 'eyes',
	PAINT = 'paint',
}
